import { WhiteLabelEntry } from '@myspot_org/ngx-core/models';

export const DEFAULT_MYSPOT_UI: Pick<WhiteLabelEntry, 'colorTheme' | 'logo'> = {
  colorTheme: 'theme-myspot',
  logo: {
    logo: '/assets/images/logos/myspot-negative.svg',
    logoMobile: '/assets/images/logos/myspot-negative.svg',
    isDefault: false,
    link: '/',
    logoAlt: 'Logo Myspot',
  },
};
